import { render, staticRenderFns } from "./LiefengErwma.vue?vue&type=template&id=0d65b706&scoped=true&"
import script from "./LiefengErwma.vue?vue&type=script&lang=js&"
export * from "./LiefengErwma.vue?vue&type=script&lang=js&"
import style0 from "./LiefengErwma.vue?vue&type=style&index=0&id=0d65b706&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65b706",
  null
  
)

export default component.exports